import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=69850818&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=69850818&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69850818",
  null
  
)

export default component.exports